<template>
  <div v-loading="loading">
    <login-header v-bind="headerInfo" @listenToChildEvent="showMsgFromChild"></login-header>
    <div class="shop" :style="{ height: screenHeight + 'px' }">
      <div class="shop__title">填写店铺信息</div>
      <div class="shop__body">
        <el-form ref="form" :model="form" :rules="rules" label-width="150px">
          <el-form-item label="店铺名称：" prop="name">
            <el-input v-model.trim="form.name" class="medium_width" maxlength="20" placeholder="请填写店铺名称"></el-input>
          </el-form-item>
          <el-form-item class="image-item" label="店铺Logo：">
            <UploadImage ref="uploadRef" :imageUrl="imageUrl" @confirm="upLoadImg" />
            <div class="suggest">上传店铺Logo，有助于用户记住您</div>
          </el-form-item>
          <el-form-item label="主营类目：" prop="industry_id">
            <el-cascader
              class="selected medium_width"
              expand-trigger="hover"
              :options="categorys"
              placeholder="请选择主营类目"
              v-model="selectedCategory"
              @change="handleChangeCategory"
              >
            </el-cascader>
          </el-form-item>
          <el-form-item label="店铺地址："  prop="province_id">
            <el-cascader
              class="selected medium_width"
              expand-trigger="hover"
              placeholder="请选择店铺地址"
              :options="region"
              v-model="selectedRegion"
              @change="handleChange"
              >
            </el-cascader>
          </el-form-item>
          <el-form-item label="地图定位：" class="map-item" prop="lng">
            <el-button type="primary" plain @click="dialogVisible = true">选择经纬度</el-button>
            <el-input
              v-model="form.lng"
              disabled
              class="small_width ml10"
              placeholder="纬度"
            ></el-input>
            <el-input
              v-model="form.lat"
              disabled
              class="small_width ml10"
              placeholder="经度"
            ></el-input>
          </el-form-item>
          <el-form-item class="is-required" label="详细地址：" prop="street">
            <el-input v-model="form.street" class="medium_width" placeholder="请输入详细地址"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button class="button_create" type="primary" @click="submit('form')">立即创建</el-button>
          </el-form-item>
        </el-form>
        <downModel />
      </div>
      <login-footer :description="desc"></login-footer>
    </div>
    <el-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="800px"
    >
      <getLatLong
        :address="form.street"
        :longitude="form.lng"
        :latitude="form.lat"
        @getLatLong="getLatLong"
      ></getLatLong>
    </el-dialog>
  </div>
</template>
<script>
import qs from 'qs'
import axios from 'axios'
import downModel from '../downModel'
import loginHeader from '../header'
import loginFooter from '../footer'
import GetLatLong from '../getLatLong/getLatLong'
import UploadImage from '../uploaderImg'
export default {
  name: 'openStore',
  components: {
    downModel,
    loginHeader,
    GetLatLong,
    loginFooter,
    UploadImage
  },
  data() {
    return {
      screenHeight: document.documentElement.clientHeight - 76,
      loading: false,
      headerInfo: {
        type: '创建店铺',
        userDisplayFlag: true,
        userName: '',
        logo: ''
      },
      desc: '',
      form: {
        name: '',
        logo: '',
        province_id: '',
        city_id: '',
        area_id: '',
        lng: '',
        lat: '',
        street: '',
        industry_id: ''
      },
      logo: [],
      selectedRegion: [], // 地区已选择值
      selectedCategory: [], // 主营类目选择值
      region: [], // 地区
      categorys: [],
      value: '',
      dialogVisible: false,
      imageUrl: '',
      rules: {
        name: [
          { required: true, message: '请填写店铺名称', trigger: 'blur' },
          { min: 2, max: 20, message: '长度在 2 到 20 个字符', trigger: 'blur' }
        ],
        industry_id: [
          { required: true, message: '请选择主营类目', trigger: 'change' }
        ],
        province_id: [
          { required: true, message: '请选择店铺地址', trigger: 'change' }
        ],
        lng: [
          { required: true, message: '请选择地图定位', trigger: 'change' }
        ],
        street: [
          { required: true, message: '请填写街道地址', trigger: 'blur' },
          { min: 2, max: 30, message: '长度在 2 到 30 个字符', trigger: 'blur' }
        ]
      }
    }
  },
  created() {
    document.title = localStorage.getItem('title')
    this.loginInfo = qs.parse(localStorage.getItem('xdata'))
    this.headerInfo.logo = this.loginInfo.logo
    this.desc = this.loginInfo.desc
    this.getCategory()
  },
  mounted() {
    this.headerInfo.userName = localStorage.getItem('mobile') || ''
    this.getRegion()
    this.get_bodyHeight()
  },
  watch: {
    screenHeight (val) {
      if (!this.timer) {
        this.screenHeight = val
        this.timer = true
        setTimeout(() => {
          this.timer = false
        }, 400)
      }
    }
  },
  methods: {
    upLoadImg(logofile) {
      this.loading = true
      QM.upload({
        url: '/upload/image',
        type: 'image',
        upload: logofile,
        success: res => {
          this.loading = false
          this.imageUrl = res.data.url
          this.$message.success(res.message)
        },
        error: err => {
          this.loading = false
          this.$message({
            showClose: true,
            message: '请检查文件类型和大小',
            type: 'error',
            center: true
          })
        }
      })
    },
    submit(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.loading = true
          let storeForm = { ...this.form }
          let typeObj = this.categorys.find(item => item.value == this.selectedCategory[0])
          storeForm.logo = this.imageUrl ? this.imageUrl : 'https://images.qmai.cn/store/2020/03/31/default_logo.png'
          storeForm.type_id = typeObj.type_id
          storeForm.is_shareware = 1
          QM.apinew({
            url: '/seller/store/create',
            method: 'post',
            data: storeForm,
            success: res => {
              this.loading = false
              this.$router.push({ path: `/index.html` })
              this.$message({
                message: res.message,
                type: 'success'
              })
            },
            error: err => {
              this.loading = false
              this.$message.error(err.message)
            }
          })
        } else {
          return false
        }
      })
    },
    showMsgFromChild(data, loadingData) {
      this.loading = loadingData
      setTimeout(() => {
        this.loading = false
        this.headerInfo.userDisplayFlag = data
        localStorage.setItem('mobile', '')
        localStorage.setItem('mytoken', '')
        this.$router.push({ path: `/login.html` })
      }, 500)
    },
    getCategory() {
      QM.apinew({
        url: '/seller/industry/tree',
        method: 'get',
        data: {
          type_ids: [40]
        },
        success: res => {
          let arr = res.data.map(item => {
            let children = []
            if (item.children) {
              children = item.children.map(obj => {
                return {
                  value: obj.id,
                  label: obj.name
                }
              })
            }
            return {
              value: item.id,
              label: item.name,
              type_id: item.type_id,
              children
            }
          })
          this.categorys = arr
        },
        error: () => {}
      })
    },
    getRegion() {
      axios
        .get('/static/js/region.json')
        .then(res => {
          this.region = res.data
        })
        .catch(err => {
          this.$message.error(err)
        })
    },
    setRegionDefalut() {
      let arr = []
      arr.push(this.form.province_id)
      arr.push(this.form.city_id)
      arr.push(this.form.area_id)
      return arr
    },
    getLatLong(val) {
      this.dialogVisible = false
      this.form.lng = val.lng.toString()
      this.form.lat = val.lat.toString()
      this.form.street = val.street
    },
    get_bodyHeight () {
      window.onresize = () => {
        return (() => {
          this.$nextTick(() => {
            window.screenHeight = document.documentElement.clientHeight - 76
            this.screenHeight = window.screenHeight
          })
        })()
      }
    },
    handleChange(value) {
      this.form.province_id = value[0]
      this.form.city_id = value[1]
      this.form.area_id = value[2]
    },
    handleChangeCategory(value) {
      this.selectedCategory = value
      this.form.industry_id = value[1]
    }
  }
}
</script>

<style lang="scss" scoped>
.shop {
  min-height: 860px;
  background: #FEDE2C url('https://img-shop.qmimg.cn/s1000184/images/2020/06/01/861c913b064874c0.png') 65px 28px no-repeat;
  background-size: 30% auto;
  padding-top: 52px;
  box-sizing: border-box;
  &__title {
    font-size: 30px;
    line-height: 1.5;
    color: #333;
    text-align: center;
    width: 100%;
    margin-bottom: 35px;
  }
  &__body {
    width: 980px;
    height: 620px;
    margin: 0 auto;
    padding: 60px 66px 60px 25px;
    background: rgba(255,255,255,1);
    box-shadow: 0px 8px 15px 0px rgba(0, 0, 0, 0.08);
    border-radius: 20px;
    position: relative;
    display: flex;
    justify-content: space-between;
    .medium_width {
      width: 300px;
    }
    .small_width {
      width: 150px;
    }
    .ml10 {
      margin-left: 10px;
    }
    .map-item {
      ::v-deep .el-form-item__content {
        display: flex;
      }
    }
  }

  .image-item {
    ::v-deep .el-form-item__label {
      padding: 30px 12px 0 0;
    }
    ::v-deep .el-form-item__content {
      display: flex;
    }
    .images-uploader {
      width: 110px;
    }
    .suggest {
      width: 350px;
      height: 110px;
      display: flex;
      align-items: flex-end;
      color: #999;
      font-size: 12px;
      text-align: left;
      margin-left: 10px;
    }
  }

  .button_create {
    width: 300px;
  }
  .footer {
    padding: 25px 0 0;
  }
}
</style>